import { render, staticRenderFns } from "./shrimpTalkSettings.vue?vue&type=template&id=c4fdeae2&"
import script from "./shrimpTalkSettings.vue?vue&type=script&lang=js&"
export * from "./shrimpTalkSettings.vue?vue&type=script&lang=js&"
import style0 from "./shrimpTalkSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports